import { useRef, useState } from "react";

export default function VerificationCodeInput({
  length = 6,
  onComplete = () => {},
}) {
  const [values, setValues] = useState(Array(length).fill(""));
  const inputsRef = useRef([]);

  const handleChange = (e, index) => {
    const val = e.target.value.replace(/[^0-9a-zA-Z]/g, "");
    if (!val) return;

    const newValues = [...values];
    newValues[index] = val[0];
    setValues(newValues);

    if (index < length - 1) {
      inputsRef.current[index + 1].focus();
    }

    if (newValues.every(v => v !== "")) {
      onComplete(newValues.join(""));
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (values[index]) {
        const newValues = [...values];
        newValues[index] = "";
        setValues(newValues);
      } else if (index > 0) {
        inputsRef.current[index - 1].focus();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text").slice(0, length);
    const chars = paste.split("");

    const newValues = [...values];
    chars.forEach((c, i) => {
      newValues[i] = c;
    });

    setValues(newValues);

    const lastIndex = chars.length - 1;
    if (lastIndex >= 0 && lastIndex < length) {
      inputsRef.current[lastIndex].focus();
    }

    if (chars.length === length) {
      onComplete(chars.join(""));
    }
  };

  return (
    <div className="vc-container" onPaste={handlePaste}>
      {values.map((v, i) => (
        <input
          key={i}
          ref={(el) => (inputsRef.current[i] = el)}
          className="vc-input"
          value={v}
          onChange={(e) => handleChange(e, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          maxLength={1}
          style={{color: 'black', fontWeight: 'bold'}}
        />
      ))}
    </div>
  );
}
